import { appLocalStorage } from 'utils/misc'
import { LANGS_AVAILABLE } from './constants'
import { LOCAL_STORAGE_I18N_VAR_NAME } from 'utils/constants'

export const getLangValue = (): string => {
  const DEFAULT_LANG_CODE = LANGS_AVAILABLE.findIndex(i => i.default)
  const LANG_CODE_STORED = appLocalStorage.getValue(LOCAL_STORAGE_I18N_VAR_NAME)

  if (LANGS_AVAILABLE.findIndex(i => i.value.includes(LANG_CODE_STORED))) {
    return LANG_CODE_STORED
  }

  return LANGS_AVAILABLE[DEFAULT_LANG_CODE].value
}
